







































































































































export default {
	name: 'SignIn',
	data() {
		return {
			form: {},
			rules: {},
			loading: false,
			loadingText: this.$t('common.loading'),
			organizationData: {
				licensePerUser: true,
				name: false,
				logo: this.$store.state.ramboxLogo,
				providers: {},
			},
		};
	},
	computed: {
		showDivider() {
			return Object.keys(this.organizationData.providers).filter(k => this.organizationData.providers[k]).length !== 0;
		},
	},
	methods: {
		async validateForm(): Promise<boolean> {
			try {
				return await this.$refs.form.validate();
			} catch (error) {
				return false;
			}
		},
		async userPassLogin(): Promise<void> {
			const valid = await this.validateForm();

			if (!valid) return;
			try {
				this.loading = true;
				this.loadingText = this.$t('signIn.authenticating');
				this.$firebase.auth().tenantId = await this.getTenantId();
				const result = await this.$firebase.auth().signInWithEmailAndPassword(this.form.email, this.form.password);
				if (result.user && !result.user.emailVerified) return this.sendVerificationEmail();
				this.loading = false;
			} catch (error) {
				console.error(error);
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		async googleLogin(): Promise<void> {
			let provider = new this.$firebase.auth.GoogleAuthProvider();
			provider.setCustomParameters({
				prompt: 'select_account',
				display: 'popup',
			});
			try {
				this.$firebase.auth().tenantId = await this.getTenantId();
				const result = await this.$firebase.auth().signInWithRedirect(provider);
			} catch (error) {
				console.error(error);
				return;
			}
		},
		async facebookLogin(): Promise<void> {
			let provider = new this.$firebase.auth.FacebookAuthProvider();
			provider.setCustomParameters({
				auth_type: 'reauthenticate',
				display: 'popup',
			});
			try {
				this.$firebase.auth().tenantId = await this.getTenantId();
				const result = await this.$firebase.auth().signInWithRedirect(provider);
				return console.log('result', result);
			} catch (error) {
				console.error(error);
				return;
			}
		},
		async microsoftLogin(): Promise<void> {
			let provider = new this.$firebase.auth.OAuthProvider('microsoft.com');
			provider.setCustomParameters({
				prompt: 'consent',
			});
			try {
				this.$firebase.auth().tenantId = await this.getTenantId();
				const result = await this.$firebase.auth().signInWithRedirect(provider);
				return console.log('result', result);
			} catch (error) {
				console.error(error);
				return;
			}
		},
		async sendVerificationEmail(): Promise<void> {
			try {
				const user = this.$firebase.auth().currentUser;
				if (!user) return;
				await this.$firebase.functions().httpsCallable('sendVerificationEmail')({
					email: user.email,
					tenantId: await this.getTenantId(),
				});
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$message({
					type: 'warning',
					message: this.$t('signIn.verifyEmail', { email: user.email }),
					duration: 0,
					closable: true,
				});
			} catch (error) {
				console.error(error);
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
				return;
			}
		},
		sendResetEmail() {
			this.$prompt(this.$t('signIn.resetPrompt.message'), this.$t('signIn.resetPrompt.title'), {
				confirmButtonText: this.$t('common.send'),
				cancelButtonText: this.$t('common.cancel'),
				type: 'warning',
				inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
				inputErrorMessage: this.$t('signIn.resetPrompt.invalidEmail'),
			})
				.then(async ({ value }) => {
					try {
						this.loading = true;
						this.loadingText = this.$t('signIn.sendingResetEmail');
						await this.$firebase.functions().httpsCallable('sendResetPasswordEmail')({
							email: value,
							tenantId: await this.getTenantId(),
						});
						this.$message({
							type: 'success',
							message: this.$t('signIn.resetPrompt.sent', { email: value }),
						});
						this.loading = false;
						this.loadingText = this.$options.data.call(this).loadingText;
					} catch (error) {
						this.loading = false;
						this.loadingText = this.$options.data.call(this).loadingText;
						this.$message({
							type: 'error',
							message: this.$translateError(error),
						});
						return;
					}
				})
				.catch(() => {});
		},
		async getOrganizationInfo(): Promise<void> {
			try {
				this.loading = true;
				this.loadingText = this.$t('signIn.gettingOrganizationInfo');
				const response = await this.$firebase.functions().httpsCallable('getOrganizationInfo')(this.$route.params.id);
				this.organizationData = response.data;
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$emit('organizationName', this.organizationData.name);
			} catch (error) {
				console.log(error);
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$alert(this.$translateError(error), this.$t('common.error'), {
					confirmButtonText: this.$t('common.ok'),
					callback: action => this.$router.push('/'),
				});
				this.organizationData = this.$options.data.call(this).organizationData;
			}
		},
		async getTenantId(): Promise<String> {
			if (this.organizationData.tenantId) return this.organizationData.tenantId;
			try {
				await this.getOrganizationInfo();
				if (!this.organizationData.tenantId) throw new Error(this.$t('signIn.noTenantId'));
				return this.organizationData.tenantId;
			} catch (error) {
				console.log(error);
				this.loading = false;
				this.$alert(this.$translateError(error), this.$t('common.error'), {
					confirmButtonText: this.$t('common.ok'),
					callback: action => this.$router.push('/'),
				});
				this.organizationData = this.$options.data.call(this).organizationData;
				return '';
			}
		},
		async getProviders(email: string, tenantId: string): Promise<string[]> {
			let arr: string[] = ['password'];
			try {
				const response = await this.$firebase.functions().httpsCallable('getUserProviders')({ email, tenantId });
				arr = response.data || ['password'];
				return arr;
			} catch (error) {
				console.error(error);
			}
			return arr;
		},
	},
	// mounted() {
	// 	this.$route.params.id && this.getOrganizationInfo();
	// },

	async mounted() {
		localStorage.clear();
		Object.keys(this.$route.query).length !== 0 && localStorage.setItem('query', JSON.stringify(this.$route.query));
		try {
			this.loading = true;
			if (this.notAllowedVersion) return (this.loading = false);
			const result = await this.$firebase.auth().getRedirectResult();
			const token = localStorage.getItem('token');
			// @ts-ignore-next-line
			this.query = JSON.parse(localStorage.getItem('query'));
			localStorage.removeItem('token');
			if (!result.user) return await this.getOrganizationInfo();

			if (!!token && result.credential.providerId === 'facebook.com') {
				// TODO: Check if the credential stored in result.credential can be used to link the account
				const credential = this.$firebase.auth.FacebookAuthProvider.credential(token);
				await result.user.linkWithCredential(credential);
				this.$message({
					type: 'success',
					message: this.$t('signIn.providerLinked', {
						provider: result.credential.providerId,
						email: result.email,
					}),
				});
			}

			this.loading = false;
		} catch (error) {
			if (error.email && error.credential && error.code === 'auth/account-exists-with-different-credential') {
				this.facebookError = error;
				// I leave the following line, because I don't fully understand if it is only necessary for the function that I just replaced or it's part
				// of the following logic as well, either way it's not harmful to leave it here.
				this.$firebase.auth().tenantId = error.tenantId;
				this.providers = await this.getProviders(error.email, error.tenantId);
				this.isFacebook = true;
				this.loading = false;
				return;
			}
			console.log(error);
			this.loading = false;
			this.loadingText = this.$options.data.call(this).loadingText;
			this.$message({
				type: 'error',
				message: this.$translateError(error),
			});
		}
	},
};
